import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  Typography,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  withStyles,
  Select,
  InputLabel,
  InputBase,
} from '@material-ui/core'

import { styled } from '@material-ui/core'
import { UpgradePopover, AccordionSummaryContent } from '../index'
import styles from '../styles'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import UserType from 'src/model/user-types'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: '100%',
  '&.Mui-expanded': {
    boxShadow: 'none',
  },
}))

const AccessTeams = props => {
  const {
    entity,
    accessRule,
    handleAccessRule,
    dispatch,
    classes,
    collectionIds,
  } = props

  const history = useHistory()

  const collectionIdFromState = useSelector(
    state => state?.collection?.collection?.id || '',
  )

  const collectionId = collectionIds || collectionIdFromState

  const onClickLearners = () => {
    if (collectionIds) {
      window.open(`/collection/${collectionId}/learners`, '_blank')
    } else {
      history.push(`/collection/${collectionId}/learners`)
    }
  }
  const handleAccessRuleChange = value => {
    if (value != accessRule) {
      handleAccessRule(value)
    }
  }
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const accessSpecificUsersControl = () => {
    if (
      userControl == 'Premium Plus' ||
      userControl == 'Premium Plus v2' ||
      userControl == 'Premium - A' ||
      userControl == 'AppSumo (Tier 3)' ||
      userControl == 'AppSumo (Tier 3A)' ||
      userControl == 'AppSumo (Tier 4)' ||
      userControl == 'AppSumo (Tier 5)' ||
      userControl == 'Elite' ||
      userControl == 'AppSumo (Tier 6)' ||
      userControl == 'AppSumo (Tier 7)' ||
      userControl == 'AppSumo (Tier 8)' ||
      userControl == 'AppSumo (Tier 9)' ||
      userControl == 'Pro' ||
      // Invitation-only access starts at Pro v2; the Plus plan doesn't include it.
      userControl == 'Pro v2' ||
      userControl == 'Launch' ||
      userControl == 'Essentials' ||
      userControl == 'Growth' ||
      userControl == 'Scale' ||
      userControl == 'Enterprise' ||
      UserType.isTrialEquivalent(userControl)
    ) {
      return false
    }
    return true
  }
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handleClickSwitch = event => {
    accessSpecificUsersControl()
      ? handleClick(event)
      : handleAccessRuleChange(2)
  }

  return (
    <div className={classes.root}>
      <StyledAccordion expanded={accessRule == 2}>
        <AccordionSummary
          className={classes.accordion__summary}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <AccordionSummaryContent
            accessRule={accessRule}
            handleClickSwitch={handleClickSwitch}
            contentHeader={'Invitation only'}
            contentDescription={'Grant access after email entry'}
            id={id}
            badgeType={2}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            popupHeader={'Upgrade to Pro'}
            popupContent={
              'Unlock exclusive features by upgrading to the Pro plan.'
            }
            accessRuleEqual={2}
          />
        </AccordionSummary>
        <AccordionDetails className={classes.accordion__details}>
          <div className={classes.accordion__details__content}>
            <CoreButton
              size="small"
              style={{ alignSelf: 'flex-start' }}
              onClick={() => {
                onClickLearners()
              }}
            >
              Go to Learners
            </CoreButton>
          </div>
        </AccordionDetails>
      </StyledAccordion>
      <UpgradePopover
        id={id}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        header={'Upgrade to Pro'}
        content={'Unlock exclusive features by upgrading to the Pro plan.'}
        accessRuleEqual={2}
      />
    </div>
  )
}

export default withStyles(styles)(AccessTeams)
